import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import logo from './assets/images/site-img/logo.png';

const LoginForm = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [userNameError, setUserNameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = true;
    if (!userName) {
      setUserNameError("Username is required.");
      valid = false;
    }else{
      setUserNameError('');
    }
    if (!password) {
      setPasswordError("Password is required.");
      valid = false;
    }
    else{
      setPasswordError('');
    }
    if(valid){
        setIsLoading(true);
        try {
          console.log('userName:', userName, 'Password:', password);
          const result = await login(userName, password);
          if (result.success) {
              navigate('/home');
          } else {
              setError(result.error);
          }
        } catch (err) {
            setError('An unexpected error occurred. Please try again.');
        } finally {
            setIsLoading(false);
        }
    }else{
        return;
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className='text-center'>
          <img src={logo} alt="ISAKOS" className='login-logo' style={{height: '60px'}} />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="userName" className="form-label">Username:</label>
            <input type="text" id="userName" className={`form-control ${userNameError ? "is-invalid" : ""}`} value={userName} 
                onChange={(e) => {
                  setUserName(e.target.value);
                  if (userNameError) setUserNameError("");
                  if(error) setError('');
                }}
            />
            {userNameError && <div className="invalid-feedback">{userNameError}</div>}
          </div>
          <div className="form-group">
            <label htmlFor="password" className="form-label">Password:</label>
            <div style={{ position: 'relative' }}>
                <input type={showPassword ? "text" : "password"} id="password" className={`form-control ${passwordError ? "is-invalid" : ""}`} value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (passwordError) setPasswordError("");
                    if(error) setError('');
                  }}
                />
                {passwordError && <div className="invalid-feedback">{passwordError}</div>}
                <i className={`fa-regular ${showPassword ? "fa-eye" : "fa-eye-slash"} password-toggle-icon ${passwordError ? "error" : ""}`}
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
            </div>
            
          </div>
          {error && <div className="invalid-feedback d-block">{error}</div>}
            {isLoading ? (
              <>
                <div className="d-flex justify-content-center align-items-center">
                    <button className="login-button mt-3" type="button">  
                      Login
                      <span className="spinner-border spinner-border-sm align-middle ms-3" role="status" aria-hidden="true"></span>
                    </button>
                </div>
              </>
            ) : (
              <button type="submit" className="login-button mt-3" onClick={handleSubmit}>
                Login
              </button>
            )}
        </form>
      </div>
    </div>
  );
};

export default LoginForm;